import { ReactNode } from "react";
import { useServerHealth } from "@/hooks/useServerHealth";
import { ServerDownOverlay } from "@/components/server-down-overlay";

interface ServerHealthWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper qui surveille la santé du serveur et affiche un overlay
 * quand le serveur est inaccessible, tout en conservant l'application
 * en arrière-plan et l'URL actuelle.
 */
export function ServerHealthWrapper({ children }: ServerHealthWrapperProps) {
  const { isDown, checkHealth, lastChecked, isManualChecking } = useServerHealth();

  const handleRetry = () => {
    checkHealth(true); // Marquer comme retry manuel
  };

  return (
    <>
      {/* L'application continue de fonctionner en arrière-plan */}
      {children}

      {/* Overlay qui s'affiche uniquement si le serveur est down */}
      {isDown && <ServerDownOverlay onRetry={handleRetry} isRetrying={isManualChecking} lastChecked={lastChecked} />}
    </>
  );
}
